import { SVGProps } from 'react';

export const XIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.707 1.707L16.293 0.292999L8.99997 7.586L1.70697 0.292999L0.292969 1.707L7.58597 9L0.292969 16.293L1.70697 17.707L8.99997 10.414L16.293 17.707L17.707 16.293L10.414 9L17.707 1.707Z"
        fill="currentColor"
      />
    </svg>
  );
};
